import Carousel from './Carousel';
import Flickity from './Flickity';
import FixedMenu from './FixedMenu';
import FixedTable from './FixedTable';
import Cloner from './Cloner';
import ContactMap from './ContactMap';
import ContactMapBubble from './ContactMapBubble';
import CookieBubble from './CookieBubble';
import DuoGallery from './DuoGallery'
import FileInput from './FileInput';
import Form from './Form';
import ImageMagnifier from './ImageMagnifier';
import Gallery from './Gallery';
import Map from './Map';
import Menu from './Menu';
import PopupOpener from './PopupOpener';
import PortfolioTable from './PortfolioTable';
import ScrollTo from './ScrollTo';
import SimpleGallery from './SimpleGallery';
import Slider from './Slider';
import StripesGallery from './StripesGallery';

const Components = {
    Carousel,
    Flickity,
    FixedMenu,
    FixedTable,
    Map,
    Cloner,
    ContactMap,
    ContactMapBubble,
    CookieBubble,
    DuoGallery,
    FileInput,
    Form,
    ImageMagnifier,
    Menu,
    Gallery,
    PopupOpener,
    PortfolioTable,
    ScrollTo,
    SimpleGallery,
    Slider,
    StripesGallery
};

export default Components;



// WEBPACK FOOTER //
// ./components/index.js